/* src/app/components/file-upload-notification/file-upload-notification-list/file-upload-notification-list.component.css */
.table-style {
  width: 100%;
}
/*# sourceMappingURL=file-upload-notification-list.component-MXNWQFCY.css.map */
